import { mapActions } from 'vuex'
import { SnackbarStyle } from '@/constants/constants'
import i18n from '@/i18n'
import authApi from '@/api/auth.api'
import { REGEX } from '@/constants/constants'
import { CALL_CENTER_EMAIL } from '../../../constants/constants'

export default {
  name: 'EmailResetPasswordComponent',
  data () {
    return {
      email: '',
      username: '',
      submitted: false,
      validForm: false,
      rules: {
        required: value => !!value || `${i18n.t('required')}`,
        email: value =>  !value || REGEX.email.test(value.toString()) || `${i18n.t('resetPassword.warningEmail')}`
      }
    }
  },
  mounted () {
    // Setea el lenguaje de los componentes de Vuetify
    this.$vuetify.lang.current = this.$i18n.locale
  },
  computed: {
  },
  methods: {
    ...mapActions({
      'showSnackbar': 'snackbar/showSnackbar',
      'closeSnackbar': 'snackbar/closeSnackbar'
    }),
    async submit () {
      this.submitted = true
      const config = {
        headers: {
          'accept-language': localStorage.getItem('locale')
        }
      }
      authApi.sendResetPasswordEmail(this.email, this.username, config).then((result) => {
        let text = this.$t('resetPassword.successfulEmailPasswordReset')
        if(result.data && result.data.toCallCenter){
          text =  this.$t('resetPassword.toCallCenterMessage') +  CALL_CENTER_EMAIL
        }
        this.showSnackbar({ visible: true, text: text, timeout: 6000, style: SnackbarStyle.SUCCESS })
        setTimeout(() => {
          this.$router.push('/login').catch(err => {
            console.log(err)
          })
        }, 6000)
      }).catch(() => {
        this.submitted = false
      })
    }
  }
}
